<template>
    <div class="articleList" v-infinite-scroll="loadMore" infinite-scroll-disabled="pullUpLoading" infinite-scroll-distance="10">
        <section class="selectFixed">
            <div class="bg_fff fixedBox flex_box fs14">
                <p :class="{ upIcon: openList === 'tendency' }" @click="openOptions('tendency')">{{ tendencyActive }}
                    <img src="../assets/img/icon/icon_down_black.svg" alt="downIcon">
                </p>
                <p :class="{ upIcon: openList === 'time' }" @click="openOptions('time')">{{ timeActive }}
                    <img src="../assets/img/icon/icon_down_black.svg" alt="downIcon">
                </p>
            </div>
        </section>
        <this-article-list v-if="renderList" :noIndex="true" :assignData="renderList" :onlyList="true" timeKey="createdStr" entity="article"></this-article-list>
        <!-- loading box -->
        <section class="loadingBg" v-if="loading">
            <mt-spinner type="double-bounce" color="#26a2ff"></mt-spinner>
        </section>
        <section v-if="openList" class="popupChooseBox">
            <EventChoose :popupVisible="popupVisible" :assignPositive="true" :renderType="openList"
                         :activeOption="activeOption" @selectedOption="selectedOption"></EventChoose>
        </section>
        <section class="footControlBox mt12">
            <p class="co_fff text_c fs18 font_b">导出</p>
        </section>
    </div>
</template>

<script>
import moment from 'moment'
import utils from "@/util/common";

export default {
    name: "ArticleList",
    components: {
        ThisArticleList(render){ require(["@/components/entity/ArticleList"], render) },
        EventChoose(render){ require(["@/components/common/EventChoose"], render) },
    },
    data() {
        return {
            loading: false,
            pullUpLoading: false,
            firstLoad: true,
            openList: '',
            tendencyActive: '',
            timeActive: '近7日',
            popupVisible: false,
            params: {
                skip: 0,
                limit: 10,
                start: moment().subtract(7, 'days').startOf('day').valueOf(),
                end: moment().endOf('day').valueOf(),
                industry: "",
                tendency: "",
                company: ""
            },
            currentPage: 0,
            activeOption: '',
            renderList: [],
        }
    },
    mounted() {
        let { industry, tendency, company } = this.$route.query;
        this.params.industry = industry;
        this.tendencyActive = tendency;
        this.params.tendency = this.tendencyActive;
        this.params.company = company
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true;
            this.pullUpLoading = true;
            let params = this.params;
            params.start = utils.getTimeName(this.timeActive)
            params.tendency = params.tendency === '敏感' ? '负面' : params.tendency === '全部倾向' ? '' : params.tendency;
            params.skip = this.currentPage * params.limit;
            let res = await this.baseApi.getArticle(params)
            if(res && res !== 'confirm') {
                this.renderList = this.renderList.concat(res.list);
                this.pullUpLoading = this.renderList.length === res.count;
                this.loading = false;

            }

        },
        async loadMore(){
            if(this.firstLoad){
                this.firstLoad = false;
                return ;
            }
            this.currentPage ++;
            await this.getData();
        },
        openOptions(name) {
            if(this.popupVisible && this.openList === name) {
                this.openList = '';
                this.popupVisible = false;
                return
            }
            this.openList = name;
            this.popupVisible = true;
            this.activeOption = this[`${ name }Active`];
        },
        selectedOption(data) {
            this[data.keyword] = data.value;
            this.openList = null;
            this.popupVisible = false;
            this.params.tendency = this.tendencyActive;
            this.params.skip = 0;
            this.currentPage = 0;
            this.renderList = [];
            this.firstLoad = true;
            this.getData()
        },
    }
}
</script>

<style lang="scss" scoped>
.articleList {
    .footControlBox {
        width: 100%;
        height: 48px;
        line-height: 48px;
        p {
            width: 100%;
            height: 48px;
            position: fixed;
            bottom: 0;
            left: 0;
            background-color: #538DFF;
        }
    }
}
</style>